import { initGallery } from "./gallery.js";

export const initSections = () => {

    initGallery();

};
